import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { UserStore } from "../stores/user.store";

export const AuthGuard: CanActivateFn = async () => {
    const store = inject(UserStore);

    try {
        const user = await store.fetchUser();
        return !!user;
    } catch (error) {
        console.error("AuthGuard: Error fetching user:", error);
        await store.logout();
        return false;
    }
};
